type Listener = (id: string | null) => void;

let _reportId: string | null = null;
const listeners: Listener[] = [];

export function getReportId(): string | null {
    return _reportId;
}

export function setReportId(id: string | null) {
    _reportId = id;
    for (const l of listeners) {
        try { l(_reportId); } catch { }
    }
}

export function subscribe(listener: Listener): () => void {
    listeners.push(listener);
    return () => {
        const idx = listeners.indexOf(listener);
        if (idx >= 0) listeners.splice(idx, 1);
    };
}
